module.exports = __webpack_public_path__ + "static/media/bg2.2629a017.jpg";